import { Modal } from './bootstrap'

/**
 * Videos im Modal starten und stoppen
 */
const videoModals = document.getElementsByClassName('video-modal');
const pageClose = document.getElementById('close-page-button')

// Für jedes VideoModal EventListener bereitstellen
for (const modal of videoModals) {
  const video = modal.querySelector('video')

  const stopVideo = () => {
    if (video) {
      video.pause()
      video.currentTime = 0
    }
  }

  const startVideo = () => {
    if (video) {
      video.play()
    }
  }

  // Modal wird geöffnet: Page-Close-Button ausblenden
  modal.addEventListener('show.bs.modal', event => {
    pageClose.classList.add('opacity-0')
  })

  // Modal ist offen: Video starten
  modal.addEventListener('shown.bs.modal', event => {
    startVideo()
  })

  // Modal wird geschlossen: Page-Close-Button einblenden & Video stoppen
  modal.addEventListener('hide.bs.modal', event => {
    pageClose.classList.remove('opacity-0')
    stopVideo()
  })
}

/**
 * Datenschutzhinweis bei Newsletter-Subscription-Form nur sichtbar, wenn Email aktiv oder mit Content
 */
const subscriptionForms = document.getElementsByClassName('hip-newsletter-subscription');

for (const form of subscriptionForms) {
  const privacyContainer = form.querySelector('.tnp-privacy-field');
  const emailInput = form.querySelector('.tnp-email');

  function checkInput() {
    if (emailInput.value !== '' || document.activeElement === emailInput) {
      privacyContainer.classList.remove('hidden');
    } else {
      privacyContainer.classList.add('hidden');
    }
  }

  emailInput.addEventListener('focus', checkInput);
  emailInput.addEventListener('blur', checkInput);
  emailInput.addEventListener('input', checkInput);

  checkInput();
}



/**
 * Alben-Links deaktivieren, um Inhalte in Modal zu öffnen
 * Lyrics in Modal öffnen nach Klick in Trackliste
 */
document.addEventListener('DOMContentLoaded', function () {
  const releaseButtons = document.getElementsByClassName('release-button');
  for (const button of releaseButtons) {
    button.addEventListener('click', event => {
      event.preventDefault();
    })
  }

  const releaseModals = document.getElementsByClassName('release-modal');
  const lyricsModal = document.getElementById('lyrics-modal');
  const lyricsTitle = lyricsModal ? lyricsModal.querySelector('.modal-title') : '';
  const lyricsSpinner = document.getElementById('lyrics-spinner');
  const lyricsContent = document.getElementById('lyrics-content');

  // Funktion zum Anzeigen des Spinners
  function showSpinner() {
    lyricsSpinner.classList.remove('d-none');
    lyricsContent.classList.add('d-none');
  }

  // Funktion zum Verbergen des Spinners
  function hideSpinner() {
    lyricsSpinner.classList.add('d-none');
    lyricsContent.classList.remove('d-none');
  }

  // Initialisieren des Lyrics-Modals
  const lyricsModalInstance = lyricsModal ? new Modal(lyricsModal, {
    backdrop: 'true', // Backdrop bleibt aktiv
    keyboard: true // Ermöglicht das Schließen mit der Escape-Taste
  }) : null;

  const handleLyricLink = (link) => {
    // Event listener, um Klick auf Lyrics-Button abzufangen
    link.addEventListener('click', function (e) {
      e.preventDefault();

      // Lyrics-Slug abrufen
      const lyricsSlug = this.getAttribute('data-lyrics-slug');

      // Vor dem Abrufen der Lyrics sofort den Spinner anzeigen
      showSpinner();

      // Modal öffnen
      lyricsTitle.innerHTML = '';
      lyricsContent.innerHTML = '';
      const modalInstance = new Modal(lyricsModal);
      modalInstance.show();

      // Lyrics-Inhalt mit der REST API abrufen
      fetch(`/wp-json/wp/v2/lyrics?slug=${lyricsSlug}`)
        .then(res => res.json())
        .then(data => {
          if (data.length > 0) {
            const lyrics = data[0];

            // Modal-Inhalte aktualisieren
            lyricsTitle.innerHTML = lyrics.title.rendered;
            lyricsContent.innerHTML = lyrics.content.rendered;

            // Spinner verstecken, nachdem der Inhalt geladen wurde
            hideSpinner();
          } else {
            console.error('Lyrics not found');
            hideSpinner();
          }
        })
        .catch(error => {
          console.error('Error:', error);
          hideSpinner();
        });
    });
  }

  for (const modal of releaseModals) {
    // Event listener, wenn das Release-Modal geöffnet wird
    modal.addEventListener('show.bs.modal', event => {
      const links = document.querySelectorAll('.lyrics-link');

      links.forEach(function (link) {
        handleLyricLink(link)
      })
    });
  }

  // Event-Listener für das Schließen des Lyrics-Modals
  lyricsModal && lyricsModal.addEventListener('hidden.bs.modal', function () {
    // Zurücksetzen des Modalinhalts
    lyricsTitle.innerHTML = '';
    lyricsContent.innerHTML = '';

    // Entfernen des spezifischen Backdrops für das Lyrics-Modal
    const lyricModalBackdrops = Array.from(document.querySelectorAll('.modal-backdrop'));
    if (lyricModalBackdrops.length > 1) {
      const lastBackdrop = lyricModalBackdrops[lyricModalBackdrops.length - 1];
      if (lastBackdrop) {
        lastBackdrop.remove();
      }
    }
  });

  // Event-Listener für den Close-Button im Lyrics-Modal
  const closeButton = lyricsModal ? lyricsModal.querySelector('.close-button') : null;
  closeButton && closeButton.addEventListener('click', function () {
    lyricsModalInstance.hide();
  });

  // Optional: Backdrop-Klick zur Steuerung des Schließens
  lyricsModal && lyricsModal.addEventListener('click', function (event) {
    if (event.target === lyricsModal) {
      lyricsModalInstance.hide();
    }
  });

  // Lyric-Links auf Single Release-Page
  const singleRelease = document.getElementById('release-content');
  if (singleRelease) {
    const links2 = singleRelease.querySelectorAll('.lyrics-link-2');
    links2.forEach(function (link) {
      handleLyricLink(link)
    })
  }
});
